import { fork, takeEvery, all, put } from 'redux-saga/effects';
import {
  BaseResponse,
  ManagerAccountApi,
  ManagerAccountControllerDtoNotificationsMarkingAsReadRequest,
  ManagerAccountControllerDtoNotificationsRemoveRequest,
  ManagerAccountControllerDtoNotificationTokenCreateRequest,
} from '../../models/src';
import config from '../../../config/config';
import {
  notificationResponse,
  setNotificationList,
} from '../../actions/notification/notificationActions';
import {
  NOTIFICATION_LIST_REQUEST,
  NOTIFICATION_READ_REQUEST,
  NOTIFICATION_REMOVE_REQUEST,
  NOTIFICATION_TOKEN_CREATE_REQUEST,
} from '../../constants/notification/notificationConstants';
import cookies from 'react-cookies';
import { initializeApp } from '../../../utils/notification/firebase-app';
import {
  getMessaging,
  getToken,
} from '../../../utils/notification/firebase-messaging';
import ManagerAccountControllerDtoNotificationListResponse
  from '../../models/src/model/ManagerAccountControllerDtoNotificationListResponse';

function initFirebase() {
  // Firebase SDK 초기화
  const firebaseConfig = {
    apiKey: 'AIzaSyDxOCqEp9X8zKkpawTUbIWKwUxQUfiR30Y',
    authDomain: 'perplayadmindev.firebaseapp.com',
    projectId: 'perplayadmindev',
    storageBucket: 'perplayadmindev.appspot.com',
    messagingSenderId: '701955476031',
    appId: '1:701955476031:web:e5a302b59261374fbf068a',
  };

  const app = initializeApp(firebaseConfig);

  // Messaging 서비스 활성화
  const messaging = getMessaging(app);

  getToken(messaging, {
    vapidKey:
      'BLhHQpJEavFi5bXVbebaBFw0Lpo0ys9C_EVKC6vQUCxZgrU_6yQmp5p6wg9gghv-Xd1ADXqezdT0Lw4Kfh_3wLc',
  })
    .then((currentToken) => {
      if (currentToken) {
        // console.log('Got token:', currentToken);
        cookies.save('fcmToken', currentToken, { path: '/' });
        // 토큰을 사용하여 알림을 보낼 수 있습니다.
      } else {
        console.log('No registration token available.');
      }
    })
    .catch((err) => {
      console.log('An error occurred while retrieving token. ', err);
    });
  // messaging.onTokenRefresh(() => {
  //   getToken(messaging, { vapidKey: 'BLhHQpJEavFi5bXVbebaBFw0Lpo0ys9C_EVKC6vQUCxZgrU_6yQmp5p6wg9gghv-Xd1ADXqezdT0Lw4Kfh_3wLc' })
  //     .then((refreshedToken) => {
  //       console.log('Token refreshed.');
  //       cookies.save('fcmToken', refreshedToken, { path: '/' });
  //       // 토큰을 사용하여 알림을 보낼 수 있습니다.
  //     })
  //     .catch((err) => {
  //       console.log('Unable to retrieve refreshed token ', err);
  //     });
  // });
}

const isServiceWorkerSupported = 'serviceWorker' in navigator; // 브라우저에 Service Worker를 등록

if (isServiceWorkerSupported) {
  navigator.serviceWorker
    .register('/firebase-messaging-sw.js', { scope: '/' })
    .then((registration) => {
      initFirebase(registration);
      console.log('[ServiceWorker] 등록 성공: ', registration.scope);
    })
    .catch((err) => {
      console.log('[ServiceWorker] 등록 실패: ', err);
    });
}

const isNotificationSupported = 'Notification' in window;

if (isNotificationSupported) {
  Notification.requestPermission().then((result) => {
    if (result === 'granted') {
      console.log('[Notification] 허용: ', result);
    } else {
      console.log('[Notification] 차단: ', result);
    }
  });
}

const api = new ManagerAccountApi(config.API_CLIENT);

// function getUrlVars() {
//   const consts = {};
//   const parts = window.location.href.replace(
//     /[?&]+([^=&]+)=([^&]*)/gi,
//     function (m, key, value) {
//       // eslint-disable-line
//       consts[key] = value;
//     },
//   );
//   return consts;
// }

//= ====================================
//  WATCHERS
//-------------------------------------
function* notificationListRequestSage() {
  try {
    const result = yield api.apiManagerAccountNotificationListPost(() => {});
    const data = api.apiClient.deserialize(result, ManagerAccountControllerDtoNotificationListResponse);

    if (data.resultCode === 200) {
      yield put(setNotificationList(data.list));
      yield put(notificationResponse(data.resultCode, data.description));
    }
  } catch (e) {
    console.log(e);
  }
}

function* notificationReadRequestSage(payload) {
  try {
    const requestData = new ManagerAccountControllerDtoNotificationsMarkingAsReadRequest();
    requestData.notificationNo = payload.notificationNo;
    console.log('요청 데이터: ', requestData);

    const result = yield api.apiManagerAccountNotificationsMarkingAsReadPost({ managerAccountControllerDtoNotificationsMarkingAsReadRequest: requestData }, () => {});
    const data = api.apiClient.deserialize(result, BaseResponse);
    console.log('요청 결과: ', data);

    if (data.resultCode === 200) {
      yield put(notificationResponse(data.resultCode, data.description));
    }
  } catch (e) {
    console.log(e);
  }
}

function* notificationRemoveRequestSaga(payload) {
  try {
    const requestData = new ManagerAccountControllerDtoNotificationsRemoveRequest();
    requestData.notificationNo = payload.notificationNo;
    console.log('요청 데이터: ', requestData);

    const result = yield api.apiManagerAccountNotificationsRemovePost({ managerAccountControllerDtoNotificationsRemoveRequest: requestData }, () => {});
    const data = api.apiClient.deserialize(result, BaseResponse);
    console.log('요청 결과: ', data);

    if (data.resultCode === 200) {
      yield put(notificationResponse(data.resultCode, data.description));
    }
  } catch (e) {
    console.log(e);
  }
}

function* notificationTokenCreateRequestSage(payload) {
  try {
    const requestData = new ManagerAccountControllerDtoNotificationTokenCreateRequest();
    requestData.token = payload.token;
    console.log('요청 데이터: ', requestData);

    const result = yield api.apiManagerAccountNotificationTokenCreatePost({ managerAccountControllerDtoNotificationTokenCreateRequest: requestData }, () => {});
    const data = api.apiClient.deserialize(result, BaseResponse);
    console.log('요청 결과: ', data);
  } catch (e) {
    console.log(e);
  }
}

function* notificationRootSaga() {
  yield all([
    takeEvery(NOTIFICATION_LIST_REQUEST, notificationListRequestSage),
    takeEvery(NOTIFICATION_READ_REQUEST, notificationReadRequestSage),
    takeEvery(NOTIFICATION_TOKEN_CREATE_REQUEST, notificationTokenCreateRequestSage),
    takeEvery(NOTIFICATION_REMOVE_REQUEST, notificationRemoveRequestSaga),
  ]);
}

const notificationSagas = [fork(notificationRootSaga)];

export default notificationSagas;
